import { connect } from "react-redux";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";

import { postRegisterUser } from "../../actions/UserAction";
import { ApplicationState } from "../../redux/ApplicationState";
import { RegisterUser } from "../../models/User";
import UserRegistration from "../components/UserRegistration";

const mapStateToProps = ({ registerUserState }: ApplicationState) => ({
  registerUserState: registerUserState.response,
  registerUserStateError: registerUserState.error
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, Action<any>>
) => {
  return {
    postRegisterUser: (payload: RegisterUser, headers: any) => {
      dispatch(postRegisterUser(payload, headers));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserRegistration);
